// extracted by mini-css-extract-plugin
export default {"card":"heatMap_card__Z8q47","footer":"heatMap_footer__+L+eI","legend":"heatMap_legend__EciQC","gradient":"heatMap_gradient__QFkbU","tooltip":"heatMap_tooltip__tyXU+"};